// extracted by mini-css-extract-plugin
module.exports = {"bg":"vps-offer-card_bg__38RYR"};